module.exports = __webpack_public_path__ + "img/logo-footer.d13db3ad.jpg";